const originalFetch = window.fetch;

window.fetch = function (...args) {
  const url = args[0];
  const isCartEndpoint =
    typeof url === "string" &&
    ["/cart/add.js", "/cart/update.js", "/cart/change.js"].some((path) =>
      url.includes(path),
    );

  if (isCartEndpoint) {
    const stack = new Error().stack || "";
    const isFromConsole =
      stack.includes("at <anonymous>") || stack.includes("VM");
    if (isFromConsole) {
      return Promise.reject("Blocked");
    }
  }

  return originalFetch.apply(this, args);
};

let freeGiftPrice = 100;
let priceArray = [0, 1];
let currentDiscountCodes = [];
let user_cart = null;
let isProcessing = false;
let showConfetti = false;
let previousBundle50mlCount = 0;
let loaderTimeout = null;
let unavailableGiftVariants = [];
let unavailableGiftLastAttempt = 0;
const UNAVAILABLE_GIFT_RETRY_INTERVAL = 60000;
let cartxRetryCount = 0;
const MAX_CARTX_RETRIES = 3;
let previousCartPrice = null;

if (window.location.pathname === "/cart") {
  const url = new URL(window.location.origin + "/");
  url.searchParams.set("open_cart", "1");
  window.location.replace(url.toString());
} else {
  fetchCart();
}

function fetchCart() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      user_cart = cart;
      previousCartPrice = cart.total_price;
      previousBundle50mlCount = getBundle50mlItemCount();
      checkDiscountCode(cart);
      cartx();

      // If we were redirected from cart page with ?open_cart=1, open drawer and clean URL
      if (new URLSearchParams(location.search).get("open_cart") === "1") {
        openDrawer({ preventDefault: function () {} });
        history.replaceState(null, "", location.pathname || "/");
      }
    })
    .catch((error) => {
      console.error("Error fetching cart:", error);
      stopLoader();
      isProcessing = false;
    });
}

function bindingEvent() {
  document
    .querySelectorAll(".cartx-bogo-offer-add-to-cart")
    .forEach((button) => {
      button.addEventListener("click", function (event) {
        event.preventDefault();

        const upsellContainer = this.closest(
          ".cartx-bogo-offer-wrap",
        )?.querySelector(".cartx-upsell-product-list");

        const variantObject = {};

        if (upsellContainer) {
          const productItems = upsellContainer.querySelectorAll(
            ".cartx-upsell-product-item",
          );

          productItems.forEach((item) => {
            const buttonWrap = item.querySelector(".cartx-product-button-wrap");

            if (buttonWrap) {
              const variantId = buttonWrap.getAttribute("data-variant-id");
              const price = buttonWrap.getAttribute("data-price");
              const productType = buttonWrap.getAttribute("data-product-type");
              const quantity = buttonWrap.getAttribute("data-quantity");
              const collectionIdsStr = buttonWrap.getAttribute('data-collection-ids');

              let collectionIds = [];
              if (collectionIdsStr) {
                try {
                  collectionIds = JSON.parse(collectionIdsStr);
                } catch (e) {}
              }

              if (variantId && price) {
                variantObject[variantId] = {
                  quantity: parseInt(quantity) || 1,
                  price: parseInt(price) || 0,
                  type: productType || "",
                  collection_ids: collectionIds,
                };
              }
            }
          });
        }

        if (Object.keys(variantObject).length > 0) {
          cartx(variantObject, "MULTI_ADD");
        }
      });
    });

  document
    .querySelectorAll(".cartx-free-claim-buttton.cartx-claim-add-to-cart")
    .forEach((button) => {
      button.addEventListener("click", () => {
        if (button.classList.contains("cartx-claim-disabled")) return;

        const variantId = button.getAttribute("data-variant-id");
        if (!variantId) return;

        const clickedGroupIndex = parseInt(button.getAttribute("data-group-index"));
        const groupMax = parseInt(button.getAttribute("data-group-max") || "1");

        const claimGiftRaw = JSON.parse(document.body.getAttribute("claimgift") || "[]");
        const applicableRule = getApplicableRule(
          claimGiftRaw,
          user_cart?.item_count || 0,
          user_cart?.total_price || 0,
        );
        const groups = applicableRule?.gift_groups || [];

        const variantObject = {};

        groups.forEach((group, groupIndex) => {
          if (groupIndex === clickedGroupIndex) return;
          group.products.forEach((pid) => {
            const cartItem = user_cart?.items.find(
              (item) => String(item.id) === String(pid),
            );
            if (cartItem) {
              variantObject[pid] = { quantity: 0, claimed_gift: "true" };
            }
          });
        });

        const sameGroup = groups[clickedGroupIndex];
        const sameGroupClaimedCount = sameGroup
          ? sameGroup.products.filter((pid) =>
              user_cart?.items.some((item) => String(item.id) === String(pid)),
            ).length
          : 0;

        if (sameGroupClaimedCount >= groupMax) {
          // FIFO swap: remove the first-added item from this group (by cart order)
          const firstAddedInGroup = user_cart?.items.find((item) =>
            sameGroup.products.some((pid) => String(item.id) === String(pid)),
          );
          if (firstAddedInGroup) {
            variantObject[String(firstAddedInGroup.id)] = { quantity: 0, claimed_gift: "true" };
          }
        }

        variantObject[variantId] = { quantity: 1, claimed_gift: "true" };

        cartx(variantObject, "ADD");
      });
    });

  document
    .querySelectorAll(".cartx-free-claim-buttton.cartx-claim-remove-from-cart")
    .forEach((button) => {
      button.addEventListener("click", (event) => {
        const variantId = button.getAttribute("data-variant-id");
        if (!variantId) return;

        const variantObject = {
          [variantId]: {
            quantity: 0,
            claimed_gift: "true",
          },
        };

        cartx(variantObject, "REMOVE");
      });
    });

  document.querySelectorAll(".prv-submit-button").forEach((button) => {
    button.addEventListener("click", function () {
      const input = this.closest(".prv-coupon-input-container").querySelector(
        ".prv-coupon-input",
      );
      applyCode(input);
    });
  });

  document.querySelectorAll(".prv-coupon-input").forEach((input) => {
    input.addEventListener("keypress", function (e) {
      if (e.key === "Enter") {
        applyCode(input);
      }
    });
  });

  document
    .querySelectorAll(".cartx-variant-upsell")
    .forEach(function (selector) {
      // Remove the previous event listener, if any
      selector.removeEventListener("change", handleVariantChange);

      // Add the new event listener
      selector.addEventListener("change", handleVariantChange);
    });

  const viewAllBtn = document.querySelector(".prv-view-all");
  const closeBtn = document.querySelector(".cartx-offer-close");
  const offerPanel = document.querySelector(".cartx-all-offers");
  const offerTitleWrapper = document.querySelector(
    ".cartx-offer-main-title-wrapper",
  );

  if (viewAllBtn && offerPanel) {
    viewAllBtn.addEventListener("click", function () {
      offerPanel.classList.add("is--visible");
    });
  }

  if (offerTitleWrapper && offerPanel) {
    offerTitleWrapper.addEventListener("click", function () {
      offerPanel.classList.add("is--visible");
    });
  }

  if (closeBtn && offerPanel) {
    closeBtn.addEventListener("click", function () {
      offerPanel.classList.remove("is--visible");
    });
  }

  const applyButtons = document.querySelectorAll(".cartx-apply-button-wrapper");
  if (applyButtons.length > 0) {
    applyButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        const couponCode = this.getAttribute("data-code");
        applyDiscount(user_cart?.token, couponCode);
      });
    });
  }

  const removeButtons = document.querySelectorAll(
    ".cartx-remove-button-wrapper",
  );
  if (removeButtons.length > 0) {
    removeButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        const couponCode = this.getAttribute("data-code");
        removeDiscount(user_cart?.token, couponCode);
      });
    });
  }

  const appliedCouponRemoveButtons = document.querySelectorAll(
    ".cartx-applied-coupon-remove",
  );
  if (appliedCouponRemoveButtons.length > 0) {
    appliedCouponRemoveButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        const couponCode = this.getAttribute("data-code");
        removeDiscount(user_cart?.token, couponCode);
      });
    });
  }

  loadedEvents();
}

function handleVariantChange(event) {
  const selectedOption = event.target.selectedOptions[0];
  const selectedVariantId = selectedOption.value;
  const variantPrice = selectedOption.getAttribute("data-price");
  const type = selectedOption.getAttribute("data-product-type");
  const image = selectedOption.getAttribute("data-image");

  const li = event.target
    .closest(".cartx-upsell-product-item")
    .querySelector(".cartx-product-button-wrap");
  if (!li) return;

  const formattedPrice = `₹ ${(parseInt(variantPrice) / 100).toFixed(2)}`;

  li
    .closest(".cartx-upsell-product-item")
    .querySelector(".cartx-upsell-item__img").src = image;
  li
    .closest(".cartx-upsell-product-item")
    .querySelector(".cartx-upsell-item__prices .current-price").innerHTML =
    formattedPrice;
  li.setAttribute("data-variant-id", selectedVariantId);
  li.setAttribute("data-price", variantPrice);
  li.setAttribute("data-product-type", type);
}

function startLoader() {
  const cartLoader = document.querySelector(".cartx-atc-cart-loading");
  if (cartLoader) {
    cartLoader.classList.add("loading");
  }

  if (loaderTimeout) {
    clearTimeout(loaderTimeout);
  }
  loaderTimeout = setTimeout(() => {
    stopLoader();
    isProcessing = false;
  }, 10000);
}

function stopLoader() {
  const cartLoader = document.querySelector(".cartx-atc-cart-loading");
  if (cartLoader) {
    cartLoader.classList.remove("loading");
  }

  if (loaderTimeout) {
    clearTimeout(loaderTimeout);
    loaderTimeout = null;
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (
          node.nodeType === 1 &&
          node.classList.contains("cartx-product-button-wrap")
        ) {
          loadedEvents();
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  loadedEvents();
});

function handleAddToCartClick(event) {
  const button = event.currentTarget;

  const wrapper = button.closest(".cartx-product-button-wrap");
  const variantId = wrapper.getAttribute("data-variant-id");
  if (!variantId) return;

  const isInDrawer = wrapper.closest(".cartx-drawer-wrap");
  const isInEmptyCart = wrapper.closest(".cartx-ec-wrapper");
  wrapper.classList.add("cartx-button-loadding");

  const collectionIdsStr = wrapper.getAttribute("data-collection-ids");
  let collectionIds = [];
  if (collectionIdsStr) {
    try {
      collectionIds = JSON.parse(collectionIdsStr);
    } catch (e) {}
  }

  const isPDP = wrapper.classList.contains("pdp-add-to-cart");
  const quantity = isPDP
    ? parseInt(wrapper.closest("form")?.querySelector('input[name="quantity"]')?.value) || 1
    : parseInt(wrapper.getAttribute("data-quantity")) || 1;

  const variantObject = {
    [variantId]: {
      quantity: quantity,
      price: parseInt(wrapper.getAttribute("data-price")) || 0,
      type: wrapper.getAttribute("data-product-type") || "",
      collection_ids: collectionIds,
    },
  };

  cartx(variantObject, "ADD", { skipLoader: isInDrawer && !isInEmptyCart });
}

function handleRemoveFromCartClick(event) {
  const button = event.currentTarget;

  const wrapper = button.closest(".cartx-product-button-wrap");
  const variantId = wrapper.getAttribute("data-variant-id");
  if (!variantId) return;

  const isInDrawer = wrapper.closest(".cartx-drawer-wrap");
  if (!isInDrawer) {
    wrapper.classList.add("cartx-button-loadding");
  }

  const collectionIdsStr = wrapper.getAttribute("data-collection-ids");
  let collectionIds = [];
  if (collectionIdsStr) {
    try {
      collectionIds = JSON.parse(collectionIdsStr);
    } catch (e) {}
  }

  const variantObject = {
    [variantId]: {
      quantity: parseInt(wrapper.getAttribute("data-quantity")) || 0,
      price: parseInt(wrapper.getAttribute("data-price")) || 0,
      type: wrapper.getAttribute("data-product-type") || "",
      collection_ids: collectionIds,
    },
  };

  cartx(variantObject, "REMOVE", { skipLoader: !!isInDrawer });
}

function loadedEvents() {
  document
    .querySelectorAll(".cartx-add-to-cart:not(.plus):not(.cartx-sold-out)")
    .forEach((button) => {
      button.removeEventListener("click", handleAddToCartClick);
      button.addEventListener("click", handleAddToCartClick);
    });

  document.querySelectorAll(".cartx-add-to-cart.plus").forEach((button) => {
    button.removeEventListener("click", handleAddToCartClick);
    button.addEventListener("click", handleAddToCartClick);
  });

  document
    .querySelectorAll(".cartx-remove-from-cart.minus")
    .forEach((button) => {
      button.removeEventListener("click", handleRemoveFromCartClick);
      button.addEventListener("click", handleRemoveFromCartClick);
    });

  document.querySelectorAll(".cartx-icon").forEach((button) => {
    button.removeEventListener("click", openDrawer);
    button.addEventListener("click", openDrawer);
  });

  const cartDrawerEl = document.querySelector("cart-drawer.cartx-drawer");
  if (cartDrawerEl) {
    cartDrawerEl.addEventListener("click", function (e) {
      if (!cartDrawerEl.classList.contains("drawer-open")) return;
      const inner = cartDrawerEl.querySelector(".cartx-drawer-inner");
      if (inner && !inner.contains(e.target)) {
        closeDrawer();
      }
    });
  }

  const overlay = document.querySelector(".cartx-drawer-overlay");
  if (overlay) {
    overlay.addEventListener("click", closeDrawer);
  }

  document
    .querySelectorAll(".cartx-variant-upsell")
    .forEach(function (selector) {
      // Remove the previous event listener, if any
      selector.removeEventListener("change", handleVariantChange);

      // Add the new event listener
      selector.addEventListener("change", handleVariantChange);
    });

  toggleOfferWrapper();
}

function openDrawer(event) {
  if (event) event.preventDefault();
  const cartDrawer = document.querySelector("cart-drawer");
  const overlay = document.querySelector(".cartx-drawer-overlay");
  if (cartDrawer && overlay) {
    cartDrawer.classList.add("drawer-open");
    overlay.classList.add("open-overlay");
  }
  document.body.classList.add("cartx-open");
}

function closeDrawer() {
  const cartDrawer = document.querySelector("cart-drawer");
  const overlay = document.querySelector(".cartx-drawer-overlay");
  if (cartDrawer && overlay) {
    cartDrawer.classList.remove("drawer-open");
    overlay.classList.remove("open-overlay");
  }

  document.body.classList.remove("cartx-open");
  document.body.classList.remove("overflow-hidden");
}

function cartx(variantObject = {}, event, options = {}) {
  if (isProcessing) {
    updateQuantity(variantObject, null);
    return;
  }

  isProcessing = true;
  if (!options.skipLoader) {
    startLoader();
  }

  const allProducts = {};

  const filteredObjects = JSON.parse(document.body.getAttribute("metaobject"));
  const cartFreebie = cleanData(
    JSON.parse(document.body.getAttribute("cartfreebie")),
  );

  let claimGift = JSON.parse(document.body.getAttribute("claimgift"));

  let localStorageClaimGift = JSON.parse(
    localStorage.getItem("claimedGiftProducts"),
  );

  const cartUpdatedObject = {};
  let totalFreeProduct = 0;
  let totalFreeProductPrice = 0;
  let totalCombosQuantity = 0;
  let totalCombosPrice = 0;

  let isClaimedGift = false;

  user_cart?.items.forEach(
    ({
      id,
      quantity,
      final_line_price,
      original_line_price,
      product_type,
      properties,
    }) => {
      const productId = id.toString();

      allProducts[productId] = Number(allProducts[productId] || 0) + quantity;

      if (!cartUpdatedObject[productId])
        cartUpdatedObject[productId] = quantity;

      if (
        (final_line_price === freeGiftPrice &&
          original_line_price === freeGiftPrice) ||
        (final_line_price === 0 && original_line_price === 0)
      ) {
        totalFreeProduct++;
        totalFreeProductPrice += final_line_price;

        // Don't remove if it's a claimed gift
        if (properties?.claimed_gift !== "true") {
          cartUpdatedObject[productId] = 0;
        }
      }

      if (product_type === "Combos") {
        totalCombosQuantity += quantity;
        totalCombosPrice += final_line_price;
      }
    },
  );

  const cartTotalProductWithoutFreebie =
    user_cart?.item_count - totalFreeProduct - totalCombosQuantity;
  const cartTotalPriceWithoutFreebie =
    user_cart?.total_price - totalFreeProductPrice - totalCombosPrice;

  let totalQuantity = 0;
  let totalPrice = 0;

  let claimedGiftProducts = {};

  Object.entries(variantObject).forEach(([key, variant]) => {
    if (variant?.replace_variant) {
      const replaceId = variant.replace_variant;

      const matchedItems = user_cart?.items.filter(
        (item) => item.id.toString() === replaceId,
      );

      const itemWithSpecificPrice = matchedItems?.find(
        (item) => Number(item.final_price) === Number(variant?.final_price),
      );

      if (itemWithSpecificPrice) {
        const oldQty = itemWithSpecificPrice.quantity;
        const oldPrice = itemWithSpecificPrice.final_line_price;

        totalQuantity -= oldQty;
        totalPrice -= oldPrice;

        cartUpdatedObject[replaceId] = 0;
      }
    }

    if (variant?.type !== "Combos" && variant?.claimed_gift !== "true") {
      totalQuantity += variant?.quantity;
      totalPrice += variant?.price * variant?.quantity;
    }

    if (variant?.claimed_gift === "true") {
      isClaimedGift = true;
      claimedGiftProducts[key] = variant?.quantity;
    }
  });

  if (Object.entries(claimedGiftProducts)?.length > 0) {
    const mergedClaimedGifts = { ...(localStorageClaimGift || {}) };
    Object.entries(claimedGiftProducts).forEach(([key, qty]) => {
      if (qty === 0) {
        delete mergedClaimedGifts[key];
      } else {
        mergedClaimedGifts[key] = qty;
      }
    });
    localStorage.setItem("claimedGiftProducts", JSON.stringify(mergedClaimedGifts));
    localStorageClaimGift = mergedClaimedGifts;
  }

  const adjustedCartQuantity =
    cartTotalProductWithoutFreebie +
    (event === "ADD" || event == "MULTI_ADD"
      ? totalQuantity
      : event === "REMOVE"
        ? -totalQuantity
        : 0);

  const adjustedCartPrice =
    cartTotalPriceWithoutFreebie +
    (event === "ADD" || event == "MULTI_ADD"
      ? totalPrice
      : event === "REMOVE"
        ? -totalPrice
        : 0);

  const discountPriceCheck =
    user_cart?.total_price +
    (event === "ADD" || event == "MULTI_ADD"
      ? totalPrice
      : event === "REMOVE"
        ? -totalPrice
        : 0);

  const applicableRule = getApplicableRule(
    filteredObjects,
    adjustedCartQuantity,
    adjustedCartPrice,
  );

  const currentApplicableGifts = [];

  const now = Date.now();
  const shouldRetryUnavailable =
    now - unavailableGiftLastAttempt >= UNAVAILABLE_GIFT_RETRY_INTERVAL;

  if (applicableRule?.get_y?.length) {
    applicableRule.get_y.forEach((variant) => {
      const variantId = variant.split("/").pop();
      currentApplicableGifts.push(variantId);

      if (!unavailableGiftVariants.includes(variantId)) {
        cartUpdatedObject[variantId] = 1;
      } else if (shouldRetryUnavailable) {
        cartUpdatedObject[variantId] = 1;
        unavailableGiftVariants = unavailableGiftVariants.filter(
          (id) => id !== variantId,
        );
        unavailableGiftLastAttempt = now;
      }
    });
  }

  unavailableGiftVariants = unavailableGiftVariants.filter((variantId) => {
    return currentApplicableGifts.includes(variantId);
  });
  updateGiftUnavailableMessage();

  const applicableRuleClaimGift = getApplicableRule(
    claimGift,
    adjustedCartQuantity,
    adjustedCartPrice,
  );

  if (applicableRuleClaimGift) {
    const groups = applicableRuleClaimGift.gift_groups || [];
    if (groups.length && localStorageClaimGift) {
      groups.forEach((group) => {
        group.products.forEach((variantGid) => {
          const variantId = variantGid.split("/").pop();
          if (
            localStorageClaimGift.hasOwnProperty(variantId) &&
            !variantObject.hasOwnProperty(variantId)
          ) {
            cartUpdatedObject[variantId] = localStorageClaimGift[variantId];
          }
        });
      });
    }
  } else if (!isClaimedGift) {
    localStorage.removeItem("claimedGiftProducts");
  }

  Object.entries(variantObject).forEach(([productId, { quantity }]) => {
    const currentQty = cartUpdatedObject[productId] || 0;
    const currentQuantiyAll = allProducts[productId] || 0;
    cartUpdatedObject[productId] =
      event === "ADD"
        ? currentQty + quantity
        : event === "MULTI_ADD"
          ? 1
          : Math.max(0, currentQty - quantity);

    allProducts[productId] =
      event === "ADD"
        ? currentQuantiyAll + quantity
        : event === "MULTI_ADD"
          ? 1
          : Math.max(0, currentQuantiyAll - quantity);
  });

  cartFreebie?.forEach(({ freebie, products }) => {
    if (freebie.length > 0) {
      products.forEach((productId) => {
        if (
          cartUpdatedObject[productId] &&
          cartUpdatedObject[productId] !== 0
        ) {
          cartUpdatedObject[freebie[0]] = 1;
        }
      });
    }
  });

  if (checkExceedLimit(allProducts, 40)) {
    showExceedingMessage("You can only add up to 40 of the same item");

    updateQuantity(variantObject, null);
    stopLoader();
    isProcessing = false;
    return;
  } else {
    try {
      const bogoRaw = document.body.getAttribute("bogooffers");
      if (bogoRaw) {
        const offers = JSON.parse(bogoRaw);
        const autoAdded = [];

        // Helper: get variant IDs that belong to the trigger collection (for price-based BOGO)
        const getTriggerVariantIds = (triggerCollectionId) => {
          const variantIds = new Set();

          const cartItems = document.querySelectorAll('.cartx-drawer-product-item[data-collection-ids]');
          cartItems.forEach((itemEl) => {
            const collectionIdsStr = itemEl.getAttribute('data-collection-ids');
            if (collectionIdsStr) {
              try {
                const collectionIds = JSON.parse(collectionIdsStr);
                if (collectionIds.includes(triggerCollectionId)) {
                  const variantId = itemEl.getAttribute('data-variant-id');
                  if (variantId) variantIds.add(String(variantId));
                }
              } catch (e) {}
            }
          });

          Object.entries(variantObject).forEach(([variantId, variant]) => {
            if (variant?.collection_ids && Array.isArray(variant.collection_ids) && variant.collection_ids.includes(triggerCollectionId)) {
              variantIds.add(String(variantId));
            }
          });

          return Array.from(variantIds);
        };

        const hasCollectionInCart = (triggerCollectionId) => {
          let totalQty = 0;

          const cartItems = document.querySelectorAll('.cartx-drawer-product-item[data-collection-ids]');
          cartItems.forEach((itemEl) => {
            const collectionIdsStr = itemEl.getAttribute('data-collection-ids');
            if (collectionIdsStr) {
              try {
                const collectionIds = JSON.parse(collectionIdsStr);
                if (collectionIds.includes(triggerCollectionId)) {
                  const variantId = itemEl.getAttribute('data-variant-id');
                  const qty = Number(allProducts[String(variantId)] || 0);
                  totalQty += qty;
                }
              } catch (e) {}
            }
          });

          Object.entries(variantObject).forEach(([variantId, variant]) => {
            if (variant?.collection_ids && Array.isArray(variant.collection_ids)) {
              if (variant.collection_ids.includes(triggerCollectionId)) {
                if (event === "ADD" || event === "MULTI_ADD") {
                  totalQty += variant.quantity || 1;
                }
              }
            }
          });

          return totalQty;
        };

        const sumQtyFor = (variantIds = []) => {
          return variantIds.reduce((sum, vid) => {
            const s = Number(allProducts[String(vid)] || 0);
            return sum + s;
          }, 0);
        };

        const getVariantPrice = (variantId) => {
          if (!user_cart?.items) return 0;

          const cartItem = user_cart.items.find(
            (item) =>
              String(item.id) === String(variantId) ||
              String(item.variant_id) === String(variantId),
          );

          return cartItem ? cartItem.price / 100 : 0; // Shopify stores prices in cents
        };

        const sumPriceFor = (variantIds = []) => {
          return variantIds.reduce((sum, vid) => {
            const qty = Number(allProducts[String(vid)] || 0);

            if (qty === 0) return sum;

            const variantPrice = getVariantPrice(vid);

            return sum + variantPrice * qty;
          }, 0);
        };

        const sumPriceForWithPending = (variantIds = []) => {
          let total = sumPriceFor(variantIds);

          Object.entries(variantObject).forEach(([productId, variant]) => {
            if (variantIds.some((vid) => String(vid) === String(productId))) {
              if (event === "ADD") {
                const addPrice = variant?.price / 100 || 0;
                total += addPrice;
              }
            }
          });

          return total;
        };

        offers.forEach((offer) => {
          if (!offer.auto_add) return;

          const triggerCollectionId = offer.trigger_collection || "";
          const offerVariantIds = offer.offer_products || [];
          const reverseOfferVariantIds = offer.reverse_offer_product || [];
          const isPriceBase = offer.is_price_base || false;

          if (offerVariantIds.length !== 1) return;

          const offerVid = offerVariantIds[0];
          const reverseOfferVid = reverseOfferVariantIds[0];
          const offerMatched = sumQtyFor(offerVariantIds);

          let triggerConditionMet = false;
          let reverseTriggerConditionMet = false;

          if (isPriceBase) {
            // Price-based trigger
            const triggerPriceNeeded = Number(offer.trigger_price || 0);
            const triggerVariantIds = getTriggerVariantIds(triggerCollectionId);
            var triggerTotalPrice = sumPriceForWithPending(triggerVariantIds);

            const reverseTriggerTotalPrice = adjustedCartPrice / 100;

            if (triggerTotalPrice > reverseTriggerTotalPrice) {
              triggerTotalPrice = reverseTriggerTotalPrice;
            }

            triggerConditionMet = triggerTotalPrice >= triggerPriceNeeded;
            reverseTriggerConditionMet =
              reverseTriggerTotalPrice >= triggerPriceNeeded;
          } else {
            const triggerCountNeeded = Number(offer.trigger_count || 1);
            const triggerMatched = hasCollectionInCart(triggerCollectionId);

            triggerConditionMet = triggerMatched >= triggerCountNeeded;
          }

          if (triggerConditionMet) {
            cartUpdatedObject[String(offerVid)] = 1;
            autoAdded.push(offerVid);
          } else {
            if (reverseTriggerConditionMet) {
              cartUpdatedObject[String(reverseOfferVid)] = 1;
              autoAdded.push(reverseOfferVid);
            }
          }
        });
      }
    } catch (err) {
      console.error("BOGO auto-add error:", err);
    }
  }

  const finalPayload = { updates: cartUpdatedObject };

  const giftVariantIds = [...currentApplicableGifts];

  if (Object.keys(cartUpdatedObject).length > 0) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        cache: "no-store",
        priority: "high",
        keepalive: true,
      },
      body: JSON.stringify(finalPayload),
    })
      .then(async (res) => {
        if (!res.ok) {
          const errorData = await res.json().catch(() => ({}));
          if (
            errorData.description &&
            errorData.description.toLowerCase().includes("cannot find variant")
          ) {
            throw {
              type: "VARIANT_NOT_FOUND",
              data: errorData,
              status: res.status,
            };
          }
          throw new Error(`devx-cartx HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        user_cart = data;
        isProcessing = false;
        checkProgressbarMilestones(data.total_price);

        if (unavailableGiftVariants.length > 0) {
          unavailableGiftVariants = unavailableGiftVariants.filter(
            (variantId) => {
              const isNowInCart = data.items?.some(
                (item) => String(item.id) === String(variantId),
              );
              return !isNowInCart;
            },
          );
          updateGiftUnavailableMessage();
        }

        const shouldOpenDrawer = event === "ADD" || event === "MULTI_ADD";
        if (
          data?.total_price !== discountPriceCheck &&
          data?.total_price !== 0
        ) {
          cartxRetryCount++;
          if (cartxRetryCount < MAX_CARTX_RETRIES) {
            cartx({}, event);
            updateQuantity(variantObject, event);
          } else {
            cartxRetryCount = 0;
            reload_cartx(false, null, shouldOpenDrawer ? openDrawer : null);
            updateQuantity(variantObject, event);
            updateBubble(user_cart?.item_count);
            checkDiscountCode(user_cart);
            checkB2At1499State();
            toggleOfferWrapper();
          }
        } else {
          cartxRetryCount = 0;
          reload_cartx(false, null, shouldOpenDrawer ? openDrawer : null);
          updateQuantity(variantObject, event);
          updateBubble(user_cart?.item_count);
          checkDiscountCode(user_cart);
          checkB2At1499State();
          toggleOfferWrapper();
        }
      })
      .catch((error) => {
        if (error.type === "VARIANT_NOT_FOUND") {
          console.error(
            "Gift product variant not found (possibly drafted):",
            error.data,
          );

          const failedVariants = findUnavailableVariants(
            cartUpdatedObject,
            giftVariantIds,
            error.data,
          );

          if (failedVariants.length > 0) {
            failedVariants.forEach((variantId) => {
              if (!unavailableGiftVariants.includes(variantId)) {
                unavailableGiftVariants.push(variantId);
              }
            });

            unavailableGiftLastAttempt = Date.now();

            const retryPayload = { ...cartUpdatedObject };
            failedVariants.forEach((variantId) => {
              delete retryPayload[variantId];
            });

            showGiftUnavailableMessage();
            updateGiftUnavailableMessage();

            if (Object.keys(retryPayload).length > 0) {
              retryCartUpdate(
                retryPayload,
                variantObject,
                event,
                discountPriceCheck,
              );
            } else {
              reload_cartx();
              stopLoader();
              isProcessing = false;
            }
          } else {
            showGiftUnavailableMessage();
            reload_cartx();
            stopLoader();
            isProcessing = false;
          }
        } else {
          console.error("devx-cartx Error updating cart:", error);
          stopLoader();
          isProcessing = false;
        }
      });
  } else {
    reload_cartx();
    checkDiscountCode(user_cart);
    toggleOfferWrapper();
    isProcessing = false;
  }
}

function findUnavailableVariants(
  cartUpdatedObject,
  giftVariantIds,
  errorData = null,
) {
  if (errorData?.description) {
    const description = errorData.description.toLowerCase();
    for (const variantId of giftVariantIds) {
      if (description.includes(variantId)) {
        return [variantId];
      }
    }
  }

  return giftVariantIds.filter((variantId) => {
    return cartUpdatedObject[variantId] && cartUpdatedObject[variantId] > 0;
  });
}

function retryCartUpdate(
  retryPayload,
  variantObject,
  event,
  discountPriceCheck,
) {
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      cache: "no-store",
      priority: "high",
      keepalive: true,
    },
    body: JSON.stringify({ updates: retryPayload }),
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error(`devx-cartx retry HTTP error! status: ${res.status}`);
      }
      return res.json();
    })
    .then((data) => {
      user_cart = data;
      isProcessing = false;
      checkProgressbarMilestones(data.total_price);

      const shouldOpenDrawer = event === "ADD" || event === "MULTI_ADD";
      if (data?.total_price !== discountPriceCheck && data?.total_price !== 0) {
        cartx({}, event);
        updateQuantity(variantObject, event);
      } else {
        reload_cartx(false, null, shouldOpenDrawer ? openDrawer : null);
        updateQuantity(variantObject, event);
        updateBubble(user_cart?.item_count);
        checkDiscountCode(user_cart);
        checkB2At1499State();
        toggleOfferWrapper();
      }
    })
    .catch((error) => {
      console.error("devx-cartx retry Error updating cart:", error);
      stopLoader();
      isProcessing = false;
    });
}

function showGiftUnavailableMessage() {
  showExceedingMessage("Gift product is currently out of stock");
}

function updateGiftUnavailableMessage() {
  const giftUnavailableSection = document.querySelector(
    ".cartx-gift-unavailable-sticky",
  );

  if (unavailableGiftVariants.length > 0) {
    if (giftUnavailableSection) {
      giftUnavailableSection.classList.remove("is-hidden");
    }
    document.body.setAttribute("data-gift-unavailable", "true");
  } else {
    if (giftUnavailableSection) {
      giftUnavailableSection.classList.add("is-hidden");
    }
    document.body.removeAttribute("data-gift-unavailable");
  }
}

function checkExceedLimit(object, limit) {
  return Object.values(object).some((value) => value > limit);
}

function hideMilestoneToast(duration = 5000) {
  setTimeout(function () {
    document.querySelector(".cartx-milestone-toast")?.classList.add("hide");
  }, duration);
}

function showMilestoneToast(message, duration = 5000) {
  const toast = document.querySelector(".cartx-milestone-toast");
  if (!toast) return;
  if (message) toast.innerHTML = message;
  toast.classList.remove("hide");
  hideMilestoneToast(duration);
}

function getBundle50mlItemCount() {
  const inner = document.querySelector('.cartx-drawer-inner');
  return parseInt(inner?.getAttribute('data-bundle-offer-item-count') || '0', 10);
}

function checkB2At1499State() {
  const currentCount = getBundle50mlItemCount();
  if (currentCount > previousBundle50mlCount && currentCount <= 2) {
    if (currentCount === 1) {
      showMilestoneToast('✨ So close!<br>Just 1 more 50ml fragrance to unlock Buy Any 2 @ ₹1499.', 10000);
    } else if (currentCount === 2) {
      fireMilestoneConfetti();
      showMilestoneToast('🎉 Congratulations! Offer Unlocked!<br>Your fragrance duo now qualifies for Buy Any 2 @ ₹1499.', 10000);
    }
  }
  previousBundle50mlCount = currentCount;
}

function cleanData(cartFreebie) {
  return cartFreebie?.map((item) => ({
    freebie: item.freebie.map((id) =>
      id.replace("gid://shopify/ProductVariant/", ""),
    ),
    products: item.products.map((id) =>
      id.replace("gid://shopify/ProductVariant/", ""),
    ),
  }));
}

function getApplicableRule(
  filteredObjects,
  adjustedCartQuantity,
  adjustedCartPrice,
) {
  if (!filteredObjects || !filteredObjects.length) return null;

  const applicableRules = filteredObjects.filter(
    ({ triggered_quantity, trigger_price }) => {
      if (triggered_quantity !== undefined) {
        return adjustedCartQuantity >= triggered_quantity;
      } else if (trigger_price !== undefined) {
        return adjustedCartPrice >= trigger_price * 100;
      }
      return false;
    },
  );

  const sortedRules = applicableRules.sort((a, b) => {
    const aVal =
      a.triggered_quantity !== undefined
        ? a.triggered_quantity
        : a.trigger_price !== undefined
          ? a.trigger_price * 100
          : 0;

    const bVal =
      b.triggered_quantity !== undefined
        ? b.triggered_quantity
        : b.trigger_price !== undefined
          ? b.trigger_price * 100
          : 0;

    return bVal - aVal; // descending
  });

  return sortedRules[0] || null;
}

function reload_cartx(cart_visible = false, event = null, afterUpdate = null) {
  const sectionId = "cartx-drawer";

  const currentInner = document.querySelector(
    `#shopify-section-${sectionId} .cartx-drawer-inner`,
  );

  const oldBottomCart = document.querySelector(
    `#shopify-section-${sectionId} #cartx-bottom-cart`,
  );
  currentInner?.classList.add("is-loading");
  const cartBodyWrap = document.querySelector(".cartx-drawer-body-wrap");
  let cartScrollPosition = cartBodyWrap ? cartBodyWrap.scrollTop : 0;

  return fetch(window.location.pathname + `?sections=${sectionId}`, {
    cache: "no-store",
    priority: "high",
    keepalive: true,
  })
    .then((res) => res.json())
    .then((data) => {
      const updated_cart_html = data[sectionId];

      const parser = new DOMParser();
      const htmlDoc = parser.parseFromString(updated_cart_html, "text/html");
      const newCartInner = htmlDoc.querySelector(".cartx-drawer-inner");
      const bottomCart = htmlDoc.getElementById("cartx-bottom-cart");

      if (newCartInner && currentInner) {
        currentInner.innerHTML = newCartInner.innerHTML;
        currentInner.setAttribute('data-bundle-offer-item-count', newCartInner.getAttribute('data-bundle-offer-item-count') || '0');
        checkB2At1499State();
        const scrollContainer = document.querySelector(
          ".cartx-drawer-body-wrap",
        );
        if (scrollContainer) {
          scrollContainer.scrollTop = cartScrollPosition;
        }
        if (showConfetti) {
          cartConfetti();
        }
        showConfetti = false;

        const ai_base_upsell = newCartInner.getAttribute("ai-cart-upsell");
        if (ai_base_upsell && ai_base_upsell == "true") {
          if (user_cart?.item_count > 0) {
            updateAiUpsell(user_cart?.items);
          }
          bindingEvent();
        } else {
          bindingEvent();
          loadedEvents();
        }
      }
      if (oldBottomCart && bottomCart) {
        oldBottomCart.innerHTML = bottomCart.innerHTML;
        if (user_cart?.item_count > 0) {
          oldBottomCart.classList.add("show-slide");
        } else {
          oldBottomCart.classList.remove("show-slide");
        }
      }

      if (afterUpdate) afterUpdate();
    })
    .catch((error) => {
      console.error("Error reloading cart:", error);
    })
    .finally(() => {
      currentInner?.classList.remove("is-loading");
      stopLoader();
      loadedEvents();
      toggleOfferWrapper();
      updateGiftUnavailableMessage(); // Update gift unavailable section visibility
    });
}
window.reload_cartx = reload_cartx;
window.start_cartx_loader = startLoader;

function updateQuantity(variantObject = {}, event) {
  if (!variantObject) return;

  Object.entries(variantObject).forEach(([productId, { quantity }]) => {
    const quantityElements = document.querySelectorAll(
      '.cartx-atc-qty[data-variant-id="' + productId + '"]',
    );

    const quantityElementsWrapper = document.querySelectorAll(
      '.cartx-product-button-wrap[data-variant-id="' + productId + '"]',
    );

    quantityElementsWrapper?.forEach((element) => {
      const el = element.querySelector(".cartx-atc-qty");

      if (el) {
        const addToCart = element.querySelector(".cartx-add-to-cart");
        const plusMinusWrapper = element.querySelector(
          ".cartx-add-to-cart-qty-wrap",
        );

        if (event) {
          if (event == "CHANGE") {
            el.value = Number(quantity);
          } else {
            el.value =
              Number(el?.value) +
              (event === "ADD" || event == "MULTI_ADD" ? 1 : -1) *
                Number(quantity);
          }
        }

        if (Number(el.value) > 0) {
          addToCart.style.display = "none";
          plusMinusWrapper.style.display = "flex";
        } else {
          addToCart.style.display = "flex";
          plusMinusWrapper.style.display = "none";
        }
      }
      // Always remove loading state, even if event is not found
      if (element.classList.contains("cartx-button-loadding")) {
        element.classList.remove("cartx-button-loadding");
      }
    });
  });
}

function updateBubble(cartCount) {
  const bubbleElements = document.querySelectorAll(".cart-count-bubble");

  const bubbleEle = document.getElementById("cart-icon-bubble");

  bubbleElements.forEach((bubble) => {
    bubbleCount(bubble, cartCount);
  });

  bubbleCount(bubbleEle, cartCount);
}

function bubbleCount(bubble, cartCount) {
  const visibleCount = bubble.querySelector('span[aria-hidden="true"]');
  const hiddenCount = bubble.querySelector(".visually-hidden");

  if (visibleCount) visibleCount.textContent = cartCount;
  if (hiddenCount) hiddenCount.textContent = `${cartCount} items`;
}

function applyCode(codeInput = null) {
  const code = (
    codeInput || document.querySelector(".prv-coupon-input")
  ).value.trim();

  applyDiscount(user_cart?.token, code);
}

function validateDiscountCode(code) {
  return code.replace(/[^\w\-]/g, "");
}

function getCartBase() {
  return (window.Shopify?.routes?.root ?? "/").replace(/\/?$/, "/");
}

function getAppliedCodesFromCart(cart) {
  if (!cart) return [];
  const codes = new Set();
  (cart.items || []).forEach((item) => {
    (item.line_level_discount_allocations || []).forEach((a) => {
      const title = a.discount_application?.title;
      if (title) codes.add(title);
    });
  });
  (cart.cart_level_discount_applications || []).forEach((d) => {
    const title = d.title ?? d.discount_application?.title;
    if (title) codes.add(title);
  });
  return [...codes];
}

function isDiscountAppliedOnCart(cart, code) {
  const codeUpper = (code || "").trim().toUpperCase();
  if (!codeUpper) return false;
  const onCart = (cart.cart_level_discount_applications || []).some(
    (d) => (d.title ?? d.discount_application?.title)?.toUpperCase() === codeUpper,
  );
  const onLine = (cart.items || []).some((item) =>
    (item.line_level_discount_allocations || []).some(
      (a) =>
        a.discount_application?.title?.toUpperCase() === codeUpper,
    ),
  );
  return onCart || onLine;
}

async function applyDiscount(_cartId, discountCode) {
  if (!discountCode) {
    showMessage("Please enter a discount code.", true);
    return;
  }

  if (typeof user_cart === "undefined" || user_cart?.item_count === 0) {
    showMessage("Your cart is empty. Add items before applying a code.", true);
    return;
  }

  const sanitizedCode = validateDiscountCode(discountCode);
  if (!sanitizedCode) {
    showMessage("Invalid discount code format.", true);
    return;
  }

  startLoader();
  showMessage("Applying discount...", false);

  const base = getCartBase();
  const updateUrl = `${base}cart/update.js`;
  const cartUrl = `${base}cart.js`;

  try {
    const currentCodes = getAppliedCodesFromCart(user_cart);
    const newList = [...currentCodes];
    if (!newList.some((c) => c.toUpperCase() === sanitizedCode.toUpperCase())) {
      newList.push(sanitizedCode);
    }
    const discountPayload = newList.join(",");

    const res = await originalFetch(updateUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ discount: discountPayload }),
    });

    const cart = await res.json().catch(() => ({}));

    if (!res.ok) {
      const msg =
        cart.message || cart.description || "Invalid or inapplicable discount code.";
      showMessage(msg, true);
      stopLoader();
      return;
    }

    const verifiedCart = await originalFetch(cartUrl)
      .then((r) => r.json())
      .catch(() => cart);

    if (!isDiscountAppliedOnCart(verifiedCart, sanitizedCode)) {
      showMessage("Invalid or inapplicable discount code.", true);
      stopLoader();
      return;
    }

    user_cart = verifiedCart;
    checkDiscountCode(verifiedCart);
    showConfetti = true;
    showMessage("Coupon applied successfully!", false);
    toggleOfferWrapper();
    const input = document.querySelector(".prv-coupon-input");
    if (input) input.value = "";
    // Refresh drawer UI in place; reload_cartx() will call stopLoader() in its finally()
    reload_cartx();
  } catch (error) {
    console.error("Error applying discount:", error);
    showMessage("Something went wrong. Please try again.", true);
    stopLoader();
  }
}

async function removeDiscount(_cartId, discountCodeToRemove) {
  startLoader();
  showMessage("Removing discount...", false);

  const base = getCartBase();
  const updateUrl = `${base}cart/update.js`;
  const cartUrl = `${base}cart.js`;

  try {
    let cart = user_cart;
    if (!cart) {
      cart = await originalFetch(cartUrl).then((r) => r.json());
    }
    const currentCodes = getAppliedCodesFromCart(cart);
    const codeUpper = (discountCodeToRemove || "").trim().toUpperCase();
    const remaining = currentCodes.filter(
      (c) => c.toUpperCase() !== codeUpper,
    );
    const discountPayload = remaining.length ? remaining.join(",") : "";

    const res = await originalFetch(updateUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ discount: discountPayload }),
    });

    const updatedCart = await res.json().catch(() => ({}));
    if (!res.ok) {
      showMessage(
        updatedCart.message ||
          updatedCart.description ||
          "Could not remove discount.",
        true,
      );
      stopLoader();
      return;
    }

    user_cart = await originalFetch(cartUrl).then((r) => r.json()).catch(() => updatedCart);
    checkDiscountCode(user_cart);
    showMessage("Discount removed.", false);
    reload_cartx();
  } catch (error) {
    console.error("Error removing discount:", error);
    showMessage("Something went wrong. Please try again.", true);
  } finally {
    stopLoader();
  }
}

function checkDiscountCode(cart) {
  const uniqueDiscountCodes = new Set();
  (cart?.items || []).forEach((item) => {
    (item.line_level_discount_allocations || [])
      .filter((a) => a.discount_application?.type === "discount_code")
      .forEach((a) => {
        const title = a.discount_application?.title;
        if (title) uniqueDiscountCodes.add(title);
      });
  });
  (cart?.cart_level_discount_applications || []).forEach((d) => {
    const type = d.type ?? d.discount_application?.type;
    const title = d.title ?? d.discount_application?.title;
    if (type === "discount_code" && title) uniqueDiscountCodes.add(title);
  });

  currentDiscountCodes = [...uniqueDiscountCodes].map((code) =>
    code.toUpperCase(),
  );
}

function showMessage(message, isError = false) {
  const messageElement = document.querySelector(".cartx-apply-code__message");
  if (!messageElement) return;

  const messageElementWrapper = document.querySelector(
    ".cartx-apply-code-wrapper",
  );
  if (!messageElementWrapper) return;

  messageElement.textContent = message;
  messageElementWrapper.classList.add("show-message");

  setTimeout(() => {
    messageElementWrapper.classList.remove("show-message");
    messageElement.textContent = "";
  }, 5000);
}

function toggleOfferWrapper() {
  const offerWrapper = document.querySelector(".cartx-offer-wrapper");
  if (!offerWrapper) return;

  const hasDiscountCodes =
    currentDiscountCodes && currentDiscountCodes.length > 0;

  offerWrapper.classList.toggle("is-hidden", hasDiscountCodes);
}

function showExceedingMessage(message) {
  const messageElement = document.querySelector(".cartx-apply-code__message"); // replace with actual selector
  if (!messageElement) return;

  const messageElementWrapper = document.querySelector(
    ".cartx-apply-code-wrapper",
  );
  if (!messageElementWrapper) return;

  messageElement.textContent = message;
  messageElementWrapper.classList.add("purple-message");
  messageElementWrapper.classList.add("show-message");

  setTimeout(() => {
    messageElementWrapper.classList.remove("purple-message");
    messageElementWrapper.classList.remove("show-message");
    messageElement.textContent = "";
  }, 2000);
}

function updateAiUpsell(variants) {
  const myHeaders = new Headers();
  myHeaders.append(
    "Authorization",
    "Bearer GROY1tOCMx2kEAcSGR0yZ6jPofuQyXNa9xr1lO6L",
  );

  const requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  const productGIDs = encodeURIComponent(
    JSON.stringify(
      variants?.map((product) => `gid://shopify/Product/${product.product_id}`),
    ),
  );

  const upsellWrap = document.querySelector(".cartx-ai-upsell");

  fetch(
    `https://gn30lesfub.execute-api.ap-south-1.amazonaws.com/prod/cba94864-a39a-4a4e-8b1d-f34f3ff23c50/datasource/e8fb16c3-6844-4440-bbdc-924d302c890d/upsell?ids=${productGIDs}`,
    requestOptions,
  )
    .then((response) => response.json())
    .then((data) => {
      const container = document.getElementById("cartx-upsell-product-list");

      if (data && data?.products?.length > 0 && Array.isArray(data?.products)) {
        data.products.forEach((product, index) => {
          if (upsellWrap) upsellWrap.classList.remove("is-hidden");

          const variant = product?.variants?.edges?.[0]?.node;
          const image = product?.variants?.edges?.[0]?.node?.image?.url || "";
          const title = product?.title || "Untitled";
          const productType = product?.productType || "";
          const productUrl =
            "/products/" + product?.handle || "javascript:void(0);";

          const variants = product?.variants?.edges || [];
          const selectedVariantId = product?.selectedVariant?.id?.replace(
            "gid://shopify/ProductVariant/",
            "",
          );
          let variantOptionsHTML = "";

          if (variants.length > 1) {
            variantOptionsHTML = `
                <div class="cartx-variant-selector-wrapper">
                  <select class="cartx-variant-dropdown-main cartx-variant-upsell">
                    ${variants
                      .map(({ node }) => {
                        const variantId = node.id.replace(
                          "gid://shopify/ProductVariant/",
                          "",
                        );
                        const price = node.price.amount * 100;
                        const title = node.title;
                        const quantity = node.inventoryQuantity || 1; // fallback if not available
                        const selectedAttr =
                          variantId === selectedVariantId ? "selected" : "";
                        const image = node.image?.url || "";

                        return `
                          <option 
                            data-quantity="1" 
                            data-image="${image}"
                            data-price="${price}" 
                            data-product-type="${productType}"
                            value="${variantId}" 
                            ${selectedAttr}
                          >
                            ${title}
                          </option>`;
                      })
                      .join("")}
                  </select>
                </div>`;
          }

          const price = variant.price.amount ? variant.price.amount / 1 : "0";
          const compareAtPrice = variant.compareAtPrice?.amount
            ? variant.compareAtPrice.amount / 1
            : "";

          const upsellDiv = document.createElement("div");
          upsellDiv.className = "cartx-upsell-product-item";
          upsellDiv.setAttribute(
            "data_prod_id",
            variant.id.replace("gid://shopify/ProductVariant/", ""),
          );

          upsellDiv.innerHTML = `
  <div class="cartx-upsell-item__media">
    <img class="cartx-upsell-item__img" width="160" height="160" src="${image}&width=320" alt="${title}">
  </div>
  <div class="cartx-upsell-item__info">
    <span class="cartx-upsell-item__name">${title}</span>
    <div class="cartx-upsell-item__price-row">
      <div class="cartx-upsell-item__prices">
        <span class="current-price">₹ ${price}</span>
      </div>
      ${variantOptionsHTML}
    </div>

    ${
      !priceArray.includes(price)
        ? `
      <div
        class="cartx-product-button-wrap"
        data-variant-id="${variant.id.replace(
          "gid://shopify/ProductVariant/",
          "",
        )}"
        data-quantity="1"
        data-price="${variant.price.amount * 100}"
        data-product-type="${productType}"
      >
        <div class="cartx-add-to-cart">
          <span>ADD TO CART</span>
        </div>
        <div class="cartx-atc-loading" style="display:none;">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <path fill="white" d="M9.9 0.2l-0.2 1c3 0.8 5.3 3.5 5.3 6.8 0 3.9-3.1 7-7 7s-7-3.1-7-7c0-3.3 2.3-6 5.3-6.8l-0.2-1c-3.5 0.9-6.1 4.1-6.1 7.8 0 4.4 3.6 8 8 8s8-3.6 8-8c0-3.7-2.6-6.9-6.1-7.8z"></path>
          </svg>
        </div>
      </div>
    `
        : ""
    }
  </div>
`;

          container.appendChild(upsellDiv);
        });
      } else {
        if (upsellWrap) upsellWrap.classList.add("is-hidden");
      }

      loadedEvents();
    })
    .catch((error) => {
      console.error("Error fetching upsell products:", error);
      if (upsellWrap) upsellWrap.classList.add("is-hidden");
    });
}

function parseMilestones() {
  try {
    const raw = document.body.dataset.milestones;
    if (!raw) return [];
    return JSON.parse(raw).map((tier) => {
      const rawMessage = tier.toaster_message || '';
      const hasText = rawMessage.replace(/<[^>]*>/g, '').trim().length > 0;
      return {
        threshold: Number(tier.trigger_price) * 100,
        confetti: tier.confetti === true,
        toasterMessage: hasText ? rawMessage : '',
      };
    });
  } catch {
    return [];
  }
}

function checkProgressbarMilestones(newCartPrice) {
  const milestones = parseMilestones();
  if (!milestones.length || previousCartPrice === null) {
    previousCartPrice = newCartPrice;
    return;
  }
  let highestCrossed = null;
  for (const milestone of milestones) {
    if (previousCartPrice < milestone.threshold && newCartPrice >= milestone.threshold) {
      if (!highestCrossed || milestone.threshold > highestCrossed.threshold) {
        highestCrossed = milestone;
      }
    }
  }
  if (highestCrossed) {
    if (highestCrossed.confetti) fireMilestoneConfetti();
    if (highestCrossed.toasterMessage) showMilestoneToast(highestCrossed.toasterMessage);
  }
  previousCartPrice = newCartPrice;
}

function fireMilestoneConfetti() {
  const container = document.createElement('div');
  container.classList.add('milestone-confetti-overlay');
  document.body.appendChild(container);

  const animation = lottie.loadAnimation({
    container,
    renderer: 'svg',
    loop: false,
    autoplay: true,
    path: 'https://cdn.shopify.com/s/files/1/0633/2183/3679/files/Main_Scene.json?v=1746784652',
  });

  animation.addEventListener('complete', () => {
    animation.destroy();
    container.remove();
  });
}

function cartConfetti() {
  var animation = lottie.loadAnimation({
    container: document.getElementById("cartx-confetti"),
    renderer: "svg",
    loop: false,
    autoplay: false,
    path: "https://cdn.shopify.com/s/files/1/0633/2183/3679/files/Main_Scene.json?v=1746784652",
  });

  showMessage("Coupon Applied Successfully!", false);
  animation.goToAndStop(0, true);
  animation.play();

  animation.addEventListener("complete", function () {
    animation.destroy();
    document.getElementById("cartx-confetti").innerHTML = "";
  });
}

let paymentMessageScrollTimer = null;
let paymentMessageRestoring = false;

document.addEventListener("scroll", function (e) {
  if (!e.target.classList || !e.target.classList.contains("cartx-drawer-body-wrap")) return;
  if (paymentMessageRestoring) return;
  const messageEl = document.querySelector(".cartx-payment-message");
  if (!messageEl) return;
  messageEl.classList.add("is-scrolling");
  clearTimeout(paymentMessageScrollTimer);
  paymentMessageScrollTimer = setTimeout(function () {
    paymentMessageRestoring = true;
    messageEl.classList.remove("is-scrolling");
    setTimeout(function () {
      paymentMessageRestoring = false;
    }, 350);
  }, 150);
}, { capture: true });

document.addEventListener("click", function (e) {
  const cartLink = e.target.closest('a[href*="/cart"]');
  if (
    cartLink &&
    !e.ctrlKey &&
    !e.metaKey &&
    !e.shiftKey &&
    cartLink.target !== "_blank"
  ) {
    try {
      const path = new URL(cartLink.href, location.origin).pathname;
      if (path === "/cart") {
        e.preventDefault();
        openDrawer(e);
        return;
      }
    } catch (_) {
      // Invalid URL, let it proceed normally
    }
  }
});
